import { IUseAsyncReturn, useAsync } from "../../hooks/useAsync";
import { useAxios } from "../../hooks/useAxios";
import { ISkill, ListSkillsOrderBy, ListSkillsOrderDir } from "../../types";

export interface IFetchSkillsOpts {
  limit: number;
  offset: number;
  query?: string;
  order_by?: ListSkillsOrderBy;
  order_dir?: ListSkillsOrderDir;
}

export interface IFetchSkillsResponse {
  skills: Array<ISkill>;
}

/**
 * Fetches skills a single time using execution parameters without
 * caching results or invalidating skill queries
 * @returns
 */
export default function useFetchSkillsOnce(): IUseAsyncReturn<
  IFetchSkillsResponse,
  IFetchSkillsOpts
> {
  const axios = useAxios();

  const fetchSkills = async ({
    limit,
    offset,
    query,
    order_by,
    order_dir,
  }: IFetchSkillsOpts) => {
    return await axios
      .get(`/v1/skills`, {
        params: {
          limit,
          offset,
          query,
          order_by: order_by || undefined,
          order_dir: order_dir || undefined,
        },
      })
      .then((r) => r.data as IFetchSkillsResponse);
  };

  const { isLoading, error, data, execute, isSuccess } = useAsync<
    IFetchSkillsResponse,
    IFetchSkillsOpts
  >(fetchSkills);

  return {
    isLoading,
    error,
    data,
    isSuccess,
    execute,
  };
}
